// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill'
import 'isomorphic-fetch'
import Vue from 'vue'
import App from './App'
import router from './router'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Notifications from 'vue-notification'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'
import InfiniteLoading from 'vue-infinite-loading'
import * as filters from './filters'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VeeValidate from './validate'
import veeValidateJa from 'vee-validate/dist/locale/ja'
import ja from 'element-ui/lib/locale/lang/ja'
import {veevalidate_attributes} from './config/const'
import vOutsideEvents from 'vue-outside-events'
import ProgressBar from 'vuejs-progress-bar'

Vue.use(ProgressBar)

Vue.use(VueAxios, axios)

Vue.axios.defaults.baseURL = process.env.API_BASE_URL
Vue.axios.defaults.headers.get['Pragma'] = 'no-cache'
Vue.axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'

Vue.router = router

Vue.use(vOutsideEvents)

Vue.use(ElementUI, { locale: ja })

veeValidateJa.attributes = veevalidate_attributes
Vue.use(VeeValidate, {
  locale: 'ja',
  dictionary: {
    ja: veeValidateJa
  }
})

VeeValidate.Validator.extend('verify_password', {
  getMessage: field => `8桁、英数字、大文字を含むパスワードを入力してください`,
  validate: value => {
    var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})')
    var onlyAlphanumeric = new RegExp(/^[A-Za-z0-9]+$/)
    return strongRegex.test(value) && onlyAlphanumeric.test(value)
  }
})

Vue.use(require('@websanova/vue-auth'), {
  auth: require('./bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  refreshData: { enabled: false },
  tokenDefaultName: 'sns'
})

Vue.use(Loading)
Vue.use(Notifications)
Vue.use(InfiniteLoading)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js